import FullscreenCarousel from '../ImageGallaryCarousel/FullscreenCarousel';

export default function Fullscreen(props) {
  const {
    isFullscreen,
    clickHandler,
    selectedImageIndex,
    product,
    setRenderFullScreen,
    user_review_images,
    desktop,
  } = props;
  setRenderFullScreen.current = clickHandler;
  return (
    <>
      {isFullscreen ? (
        <FullscreenCarousel
          selectedImageIndex={selectedImageIndex}
          product={product}
          user_review_images={user_review_images}
          desktop={desktop}
        />
      ) : null}
    </>
  );
}
